<template>
    <div class="relative w-screen z-[999] h-screen mt-40 overflow-hidden bg-black text-white">
      <!-- Floating Images -->
      <div class="absolute w-80 top-[10vh] left-[5vw] md:left-[20vw] animate-float">
        <img src="../assets/imgs/party-imgs/img-1.png" alt="Image 1" />
      </div>
      <div class=" absolute w-72 top-[25vh] md:top-[10vh] right-[5vw] md:right-[20vw] animate-float">
        <img src="../assets/imgs/party-imgs/img-2.png" alt="Image 2" />
      </div>
      <div class="hidden md:block absolute w-70  top-[20vh] left-[70vw] animate-float">
        <img src="../assets/imgs/party-imgs/img-3.png" alt="Image 3" />
      </div>
      <div class="hidden md:block absolute w-64 top-[65vh] right-[7vw] animate-float">
        <img src="../assets/imgs/party-imgs/img-4.png" alt="Image 4" />
      </div>
      <div class="absolute w-82 top-[75vh] md:top-[65vh] left-[35vw] animate-float">
        <img src="../assets/imgs/party-imgs/img-5.png" alt="Image 5" />
      </div>
      <div class=" absolute w-60 top-[80vh] left-[5vw] animate-float">
        <img src="../assets/imgs/party-imgs/img-6.png" alt="Image 6" />
      </div>
  
      <!-- Centered Text and Buttons -->
      <div class="absolute inset-0 flex flex-col items-center justify-center">
        <div class="relative w-full flex justify-center items-end text-container">
          <div class="relative w-full">
            <h1
              v-for="(quote, index) in quotes"
              :key="index"
              class="slide absolute text-center px-5 md:px-24 w-full text-2xl md:text-4xl font-medium uppercase font-primary transition-opacity duration-500 ease-in-out"
              :class="currentSlide === index ? 'opacity-100' : 'opacity-0'"
            >
              {{ quote }}
            </h1>
          </div>
        </div>
        <div class="flex space-x-4 mt-4">
          <button
            @click="prevSlide"
            class="px-4 py-2 bg-white md:hover:bg-black border md:hover:border-white border-transparent md:hover:text-white duration-300 font-primary text-black rounded-full"
          >
            BACK
          </button>
          <button
            @click="nextSlide"
            class="px-4 py-2 bg-white md:hover:bg-black border md:hover:border-white border-transparent md:hover:text-white duration-300 font-primary text-black rounded-full"
          >
            NEXT
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from "vue";
  
  const currentSlide = ref(0);
  
  const quotes = [
    "“Aufwachen und denken, fuck, ich weißs schon wieder nichts mehr.”",
    "“Ich will nur wissen, ob irgendwas Kriminelles passiert ist.”",
    "“Wenn du dich so zur Besinnungslosigkeit betrinkst, ist das irgendwann jenseits von Gut und Böse.”",
    "“Ich war nicht labil, weil ich getrunken habe, sondern ich habe getrunken, weil ich labil war.”",
    "“Ich will ja schon immer wissen, was für einen Scheiß ich im Blackout angestellt habe.”",
    "“Ein Umfeld, in dem man sich wohl fühlt und auch mit Blackouts umsorgt wird, finde ich Goldwert.”",
    "“Mit wem ich trinke ist mir egal. Irgendwie komme ich schon heim, irgendwie komme ich schon ins Bett.”"
  ];
  
  const prevSlide = () => {
    currentSlide.value = currentSlide.value === 0 ? quotes.length - 1 : currentSlide.value - 1;
    console.log(currentSlide.value);
  };
  const nextSlide = () => {
    currentSlide.value = currentSlide.value === quotes.length - 1 ? 0 : currentSlide.value + 1;
    console.log(currentSlide.value);
  };
  </script>
  
  <style scoped>
  @keyframes float-one {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }
  @keyframes float-two {
    0%,
    100% {
      transform: translateY(-20px);
    }
    50% {
      transform: translateY(0);
    }
  }
  
  .animate-float:nth-child(n) {
    animation: float-one 6s ease-in-out infinite;
  }
  .animate-float:nth-child(3),
  .animate-float:nth-child(5) {
    animation: float-two 6s ease-in-out infinite;
  }
  
  .text-container {
    min-height: 25vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  
  .slide {
    bottom: 0;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  </style>